<template>
  <div class="banner-pending">
    <div class="banner-pending__text-container">
      <p class="Body3">On-Demand Consultation Status</p>
      <p class="Title1">Waiting for Approval</p>
    </div>

    <pulsate-icon size="large"
                  pulsate-color="blue"
                  class="banner-pending__right-icon">
      <img :src="$options.NSLogo" alt="">
    </pulsate-icon>
  </div>
</template>

<script>
  import PulsateIcon from '@/views/ondemand/components/pulsate-icon.vue';
  import NSLogo from '@/assets/icons/now-serving-heart.svg';

  export default {
    name: 'banner-pending',
    components: {
      PulsateIcon
    },
    NSLogo,
  }
</script>

<style lang="scss">
  @import "@/assets/styles/applications.scss";

  .banner-pending {
    @extend %layout--flex-row-center-x;
    position: relative;
    overflow: hidden;

    &__right-icon {
      position: absolute;
      right: -40px;
      top: -50px;

      img {
        height: 50px;
      }
    }

    &__timer {
      @extend %layout--flex-center-xy;

      .countdown {
        color: color(dodgerBlue);
        font-size: 36px;
        font-family: $D-DIN-Bold;
        line-height: normal;
      }

      .timer-title {
        color: #736FDC;
        font-size: 12px;
        font-family: $D-DIN-Bold;
        text-transform: uppercase;
      }
    }
  }
</style>